import React from 'react';
import { Box, Hidden } from '@drivekyte/web-components';
import { useMedia, Typography } from '@drivekyte/ui';
import styled from 'styled-components';
import useTranslation from '@/hooks/use-translation';

type FeaturedIn = {
  name: string;
  src: string;
};

const FEATURED_IN: Array<FeaturedIn> = [
  {
    name: 'Forbes',
    src: '/images/featured-in/forbes.png',
  },
  {
    name: 'Fortune',
    src: '/images/featured-in/fortune.png',
  },
  {
    name: 'Tech Church',
    src: '/images/featured-in/tech-crunch.png',
  },
  {
    name: 'New York Business Journal',
    src: '/images/featured-in/ny.png',
  },
];

const AsFeaturedIn = () => {
  const media = useMedia();
  const isMobile = media.xs;

  const { t } = useTranslation('components.growth.search.as-featured-in');
  const featuedIn = isMobile
    ? FEATURED_IN.filter((_, index) => index < 3)
    : FEATURED_IN;

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      style={{
        width: isMobile ? undefined : '100%',
        maxWidth: isMobile ? undefined : '1355px',
        margin: 'auto',
      }}
    >
      <Hidden smDown>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <Typography color="$contentSecondary" variant="labelSmall">
            {t('title').toLocaleUpperCase()}
          </Typography>
        </Box>
      </Hidden>
      <Box
        display="flex"
        flexDirection="row"
        marginBottom={!isMobile ? 'none' : 'base'}
        justifyContent="space-around"
      >
        {featuedIn.map(({ name, src }) => (
          <Box key={name} display="flex">
            <PartnerImage src={src} alt={name} isMobile={isMobile} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const PartnerImage = styled.img<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '272px')};
  ${({ isMobile }) => (!isMobile ? `height: 98px` : '')};
  object-fit: contain;
  opacity: 0.3;
`;

export default AsFeaturedIn;
